export default "__VITE_ASSET__a63837c3__"